import { callFunctionSafe } from "src/firebase/functions";
import { executeQuery } from "src/store";
import { baseService } from "src/store/base.store";
import {
  TremendousProductSearchPayload,
  TremendousProductSearchResponse,
} from "./types/tremendous.entity";

export const tremendousService = baseService.injectEndpoints({
  endpoints: (builder) => ({
    searchTremendousProducts: builder.mutation<
      TremendousProductSearchResponse,
      TremendousProductSearchPayload
    >({
      queryFn: async (payload) =>
        executeQuery(async () => {
          const result = await callFunctionSafe<
            TremendousProductSearchResponse,
            TremendousProductSearchPayload
          >("searchTremendousProducts", payload);
          if ("data" in result && result.data) {
            return result.data;
          }

          return { products: [] };
        }),
    }),
  }),
});

export const { useSearchTremendousProductsMutation } = tremendousService;
